import './style.scss';
import Thumbnails from './thumbnails.js';

export default Thumbnails;